import { render, staticRenderFns } from "./GoodsClass.vue?vue&type=template&id=726b9130&scoped=true&"
import script from "./GoodsClass.vue?vue&type=script&lang=js&"
export * from "./GoodsClass.vue?vue&type=script&lang=js&"
import style0 from "./GoodsClass.vue?vue&type=style&index=0&id=726b9130&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726b9130",
  null
  
)

export default component.exports